/**
 * UTF-8-safe base64 <-> text helpers. Plain atob()/btoa() only round-trip
 * Latin-1 correctly — GitHub's blob API always returns base64 (even for
 * design.json/manifest.json's UTF-8 text), so decoding a name/description
 * with non-ASCII characters through naive atob() would corrupt it.
 */

export function base64ToText(base64) {
    const binary = atob(base64.replace(/\n/g, ''));
    const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
    return new TextDecoder('utf-8').decode(bytes);
}

export function textToBase64(text) {
    const bytes = new TextEncoder().encode(text);
    let binary = '';
    for (const byte of bytes) binary += String.fromCharCode(byte);
    return btoa(binary);
}
